import DOMPurify from 'isomorphic-dompurify';

export const sanitiseText = (text, config) => {
  return DOMPurify.sanitize(text, config);
};
